module.exports = __webpack_public_path__ + "img/Bag.83dfd932.svg";